import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipo-medio-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  tamano = document.body.clientHeight;
}